<template>
  <div class="metric-survey-rr">
    <div class="response-group"
      v-for="r in responseGroups"
      v-if="hasResponseGroup(r)"
      :key="r"
      >{{nameForGroup(r)}}: {{responseRateForGroup(r)}} <span v-if="isSchoolDataLoaded">({{responseRecForGroup(r)}} surveys submitted)</span></div>
    <div class="more-survey"><LinkExternalUrl :url="panoramaURL">View responses to all of the NYC survey questions</LinkExternalUrl></div>
  </div>
</template>

<script>
import Component from 'vue-class-component'
import { mapGetters } from 'vuex'

import { NS_CURRENT_REPORT } from '../const'

import MetadataBase from './MetadataBase'
import LinkExternalUrl from '@/components/LinkExternalUrl'

const responseGroupName = {
  't': 'Teachers',
  'p': 'Families',
  's': 'Students'
}
const responseGroupLookup = {
  't': 'teacher',
  'p': 'parent',
  's': 'student'
}

/* Valid Slot Names for this Component */
const SN_RR_BY_GROUP = {}
const SN_REC_BY_GROUP = {}
Object.keys(responseGroupLookup).map(d => {
  SN_RR_BY_GROUP[d] = responseGroupLookup[d] + '_rr'
  SN_REC_BY_GROUP[d] = responseGroupLookup[d] + '_rec'
})

@Component({
  computed: {
    ...mapGetters(NS_CURRENT_REPORT, [
      'selectedSchoolHasPK',
      'panoramaURL'
    ])
  },
  components: {
    LinkExternalUrl
  }
})
export default class MetricSurveyRR extends MetadataBase {
  responseGroups = ['p', 't', 's'] // Display order

  /* Getters */

  /* Methods - utility */

  hasResponseGroup (r) {
    return this.hasSlotName(SN_RR_BY_GROUP[r])
  }
  nameForGroup (r) {
    let ret = responseGroupName[r]
    if (r === 'p' && this.selectedSchoolHasPK) {
      ret += ' (not including Pre-K)'
    }
    return ret
  }
  responseRateForGroup (r) {
    return this.dispValueForSlotName(SN_RR_BY_GROUP[r])
  }
  responseRecForGroup (r) {
    return this.dispValueForSlotName(SN_REC_BY_GROUP[r])
  }
}
</script>

<style lang="scss">
</style>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import '../css/const.scss';
.response-group {
  display: block;
  padding-right: 24px;
  &:last-child {
    padding-right: 0px;
  }
  padding-left: $info-desc-indent;
  text-indent: -$info-desc-indent;
}
.more-survey {
  padding-top: 1em;
  font-style: italic;
}
</style>



// WEBPACK FOOTER //
// src/components/sqs/2024/tab-mods/MetricSurveyRR.vue